export const props = {
  holeIndex: {
    type: String,
    required: true
  },
  slug: {
    type: String,
    required: true
  }
}
